export const mute = (
	color = '#403F42'
) => `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 11L16 13" stroke="${color}" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16 11L18 13" stroke="${color}" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.2759 7.59054C12.9377 7.11778 13.8571 7.5909 13.8571 8.40427V15.9464C13.8571 16.7598 12.9377 17.2329 12.2759 16.7601L9.85712 15.0325H9C7.89543 15.0325 7 14.137 7 13.0325V11.3182C7 10.2136 7.89543 9.31821 9 9.31821H9.85712L12.2759 7.59054Z" 
        fill="${color}"/>
    </svg>`;
